<template>
  <div class="rms-open-table">
    <a-spin :spinning="loading">
      <a-layout>
        <a-layout-content>
          <div class="form-box">
            <div class="title">
              基础信息
            </div>
            <data-form
              ref="orderForm"
              labelSize="small"
              :content="orderFormContent"
              :fixedLabelWidth="true"
              :labelCol="5"
              :wrapperCol="19"
              :colnum="4"
              :showButton="false"
            >
            </data-form>
          </div>
          <div class="form-box">
            <div class="title">
              客人信息
            </div>
            <data-form
              ref="guestForm"
              labelSize="small"
              :content="guestFormContent"
              :fixedLabelWidth="true"
              :labelCol="6"
              :wrapperCol="18"
              :colnum="3"
              :showButton="false"
            >
              <template slot="cardNo">
                <span
                  class="card-no"
                  style="float:left;width: calc(100% - 69px);"
                  @click="handleMemberCardNo"
                  >{{ member.Name }}
                  <span class="clear" @click="clearMemberCardNo">
                    <a-icon type="close-circle"
                  /></span>
                </span>
                <a-button
                  type="primary"
                  @click="readCard"
                  style="margin-top:5px;margin-left:5px"
                  >读卡</a-button
                >
              </template>
            </data-form>
          </div>
          <div class="title">
            开台餐桌
          </div>
          <div class="open-table-list float-box">
            <div
              v-for="item in openTableList"
              :key="item.id"
              class="open-table-item checked"
            >
              <div class="flex">
                <div class="flex-item">{{ item.Code }}</div>
                <div class="flex-item tc">
                  <i class="iconfont icon-yizi"></i>
                  {{ item.Seat }}
                </div>
                <div class="flex-item tr">
                  <div class="item-close" @click="removeOpenTable(item)">
                    <a-icon type="close" />
                  </div>
                </div>
              </div>
              <div class="item-title tc">
                {{ item.TableName }}
              </div>
              <a-icon type="check" class="check-icon" />
            </div>
          </div>
          <div class="footer-action-box">
            <a-button type="primary" @click="onSubmit(0)">开台点菜</a-button>
            <a-button type="primary" @click="onSubmit(1)">仅开台</a-button>
            <a-popconfirm
              title="确定取消开台吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="$router.push({ name: 'RestaurantIndex' })"
            >
              <a-button>取消</a-button>
            </a-popconfirm>
          </div>
        </a-layout-content>
        <a-layout-sider class="" style="background:#fff;" width="30%">
          <div class="table-select-wraper">
            <div class="title" style="margin-bottom:10px;">
              选择桌台
            </div>
            <div class="table-select-header"></div>
            <div class="table-select-list open-table-list">
              <div
                v-for="item in selectTableList"
                :key="item.TableId"
                class="open-table-item"
                @click="addOpenTable(item)"
              >
                <div class="flex">
                  <div class="flex-item">{{ item.Code }}</div>
                  <div class="flex-item tc">
                    <i class="iconfont icon-yizi"></i>
                    {{ item.Seat }}
                  </div>
                  <div class="flex-item tr"></div>
                </div>
                <div class="item-title tc">
                  {{ item.TableName }}
                </div>
              </div>
            </div>
          </div>
        </a-layout-sider>
      </a-layout>
    </a-spin>
  </div>
</template>
<script>
import { DataForm } from "@/components/dataForm";
import "./rms.less";
import "./openTable.less";
import { MemberListModal } from "@/views/roommanage/index.js";

export default {
  components: {
    DataForm
  },
  data() {
    return {
      orderFormContent: [
        {
          label: "就餐人数",
          name: "PersonCount",
          type: "number",
          option: {
            initialValue: 1
          }
        },
        {
          label: "客源",
          name: "GuestSourceId",
          type: "select",
          api: "Common_GetSelect",
          param: { Types: "ResGuestSource" },
          dataField: "Data.ResGuestSource"
        },
        {
          label: "客户",
          name: "CustomerId",
          type: "select",
          api: "Common_GetSelect", //请求接口api
          param: { Types: "customer" }, //请求参数
          dataField: "Data.customer", //请求可选项返回的数据字段
          props: {
            showSearch: true,
            optionFilterProp: "children"
          }
        },
        {
          name: "SalesmanName",
          type: "hidden"
        },
        {
          label: "业务员",
          name: "SalesmanId",
          type: "select",
          api: "Common_GetSelect", //请求接口api
          param: { Types: "Salesman" }, //请求参数
          dataField: "Data.Salesman", //请求可选项返回的数据字段
          onChange: this.onSalesmanChange
        }
      ],
      guestFormContent: [
        {
          label: "会员卡",
          placeholder: "请输入会员卡",
          slot: "cardNo"
        },
        {
          label: "联系人",
          name: "Contact"
        },

        {
          label: "电话",
          placeholder: "请输入电话",
          // slot: "phone",
          name: "Phone",
          option: {
            rules: [
              {
                validator: (rule, value, callback) => {
                  const val = value && value.trim();
                  if (val && !/^1[3456789]\d{9}$/.test(val)) {
                    callback(new Error("电话号码格式错误!"));
                  } else {
                    callback();
                  }
                }
              }
            ]
          },
          onChange: e => {
            const val = e.target.value;
            if (/^1[3456789]\d{9}$/.test(val)) {
              this.$post("MemberInfoGetList", {
                Keyword: val,
                PageIndex: 0,
                PageSize: 100
              }).then(res => {
                if (res.Data && res.Data.Datas && res.Data.Datas.length) {
                  const data = res.Data.Datas[0];
                  this.member = data;
                  const formData = this.$refs.guestForm.getData();
                  this.$refs.guestForm.setData({
                    ...formData,
                    Contact: data.Name
                  });
                }
              });
            }
          }
        },
        {
          label: "备注",
          name: "OrderRemark",
          type: "textarea",
          colnum: 3
        }
      ],
      // 已选桌台数据
      openTableList: [],
      //可选桌台请求来的所有数据
      selectTableAllData: [],
      member: {},
      spinning: false,
      defaultItem: {},
      routeQuery: {},
      loading: false
    };
  },
  computed: {
    //显示的可选桌台
    selectTableList() {
      const { selectTableAllData, openTableList } = this;
      const openTableIds = openTableList.map(p => p.TableId);
      return selectTableAllData.filter(
        item => !openTableIds.includes(item.TableId)
      );
    }
  },
  created() {
    this.fetchDefaultItem();
    this.fetchSelectTableList();
  },
  mounted() {
    this.$refs.orderForm.setData({
      PersonCount: 1
    });
  },
  methods: {
    fetchDefaultItem() {
      this.$post("Room_GetDefaultTime", {}).then(res => {
        res.Data.SystemConstList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });
      });
    },
    fetchSelectTableList() {
      this.$post("RMS_GetTableStatus", {
        OnlyVaild: true
      }).then(res => {
        this.selectTableAllData = res.Data.TableStatusDetails;
        this.routeQuery = this.$route.query;
        if (this.routeQuery && this.routeQuery.tableId) {
          this.openTableList = this.selectTableAllData.filter(
            el => el.TableId == this.routeQuery.tableId
          );
        }
      });
    },
    addOpenTable(item) {
      const hasItem = this.openTableList.find(p => p.TableId === item.TableId);
      if (hasItem && hasItem.TableId) {
        this.$message.error("该台已选择，请选择其它台");
        return;
      }
      this.openTableList = [...this.openTableList, item];
    },
    removeOpenTable(item) {
      this.openTableList = this.openTableList.filter(
        p => p.TableId !== item.TableId
      );
    },
    //选择会员卡
    handleMemberCardNo() {
      const that = this;
      MemberListModal({
        option: {
          defaultItem: this.defaultItem
        },
        // isNeedPass: true,
        update: data => {
          that.member = data;
          const guestForm = that.$refs.guestForm;
          guestForm.setData({
            Contact: data.Name,
            Phone: data.Phone
          });
        }
      });
    },
    clearMemberCardNo(e) {
      e.stopPropagation();
      this.member = {};
      const guestForm = this.$refs.guestForm;
      guestForm.setData({
        Contact: "",
        Phone: ""
      });
    },
    readCard() {
      const port = this.defaultItem ? this.defaultItem.LocalServicePort : "";
      const url = "http://localhost:" + port + "/MemberCard/ReadId";
      this.spinning = true;
      this.$post(url)
        .then(res => {
          if (res.Data) {
            this.getMemberList(res.Data);
          } else {
            this.$message.info("请重新放置会员卡！");
          }
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    getMemberList(physicalId) {
      this.$post("MemberInfoGetList", {
        PhysicalId: physicalId,
        PageIndex: 0,
        PageSize: 100
      }).then(res => {
        if (res.Data && res.Data.Datas && res.Data.Datas.length) {
          const data = res.Data.Datas[0];
          this.member = data;
        } else {
          this.$message.info("查不到该会员卡信息，请重试！");
        }
      });
    },
    onSalesmanChange(val, row) {
      const name = val ? row.Text : "";
      this.$refs.orderForm.setData({
        SalesmanName: name
      });
    },
    async onSubmit(type) {
      const { $refs, member, openTableList } = this;
      this.loading = true;
      const orderForm = $refs.orderForm;
      const guestForm = $refs.guestForm;
      try {
        const orderFormData = await orderForm.getData(true);
        const guestFormData = await guestForm.getData(true);
        const tableIds = openTableList.map(p => p.TableId);
        const json = {
          ...orderFormData,
          ...guestFormData,
          MemberCardId: member.Id,
          TableIds: tableIds
        };
        if (!tableIds || !tableIds.length) {
          this.$message.warning("请选择桌台");
          this.loading = false;
          return false;
        }
        this.$post("RMS_CreateOrder", json)
          .then(res => {
            this.loading = false;
            this.$message.success("开台成功");
            if (type === 1) {
              // 仅开台，返回工作台
              this.$router.push({
                name: "RestaurantIndex"
              });
            } else {
              // 开台点菜
              this.$router.push({
                name: "OrderFood",
                query: {
                  orderId: res.Data.Id
                }
              });
            }
          })
          .catch(() => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.open-table-list {
  height: calc(100vh - 465px);
}
</style>
